<template>
  <div id="app" :style="cssProps" v-if="loaded">
    <v-app id="desktop_app">
      <v-dialog v-model="global_warning.active" persistant max-width="500">
        <v-card>
          <v-card-title class="headline">
            <v-icon class="notranslate" color="warning" left>info</v-icon>
            {{ $t('Alert') }}
          </v-card-title>
          <v-card-text>{{ global_warning.text }}</v-card-text>
          <v-card-actions>
            <v-btn flat @click="global_warning.active = false">{{ $t('close') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed color="warning" :href="global_warning['link']" target="_blank">{{ $t('Vote') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <TopBar/>
      <div class="main-wrapper">
        <Menu/>
        <div class="app-content">
          <transition name="fade-slide" mode="out-in">
            <router-view></router-view>
          </transition>
        </div>
      </div>
      <transition name="fade">
        <PaymentLoader v-if="paymentLoaderActive"/>
      </transition>
    </v-app>
    <MobileApp id="mobile_app"></MobileApp>
  </div>
</template>

<script>
import MobileApp from './components/MobileApp'
import Menu from './components/Menu'
import TopBar from './components/TopBar'
import * as api from './utils/api'
import VApp from 'vuetify/es5/components/VApp/VApp'
import VDialog from 'vuetify/es5/components/VDialog/VDialog'
import VCard from 'vuetify/es5/components/VCard/VCard'
import VBtn from 'vuetify/es5/components/VBtn/VBtn'
import VIcon from 'vuetify/es5/components/VIcon/VIcon'
import {
  UPDATE_SEGMENTS,
  UPDATE_USER
} from './store/types'
import PaymentLoader from './components/PaymentLoader'
import { removeURLParam } from './utils/functions'
export default {
  components: { MobileApp, PaymentLoader, VApp, TopBar, Menu, VDialog, VCard, VBtn, VIcon },
  data: () => ({
    loaded: false,
    global_warning: {
      active: false
    }
  }),
  computed: {
    cssProps () {
      return {
        '--accent-color': this.$vuetify.theme.accent,
        '--success-color': this.$vuetify.theme.success,
        '--error-color': this.$vuetify.theme.error,
        '--warning-color': this.$vuetify.theme.warning,
        '--info-color': this.$vuetify.theme.info,
        '--awards-rated-5': this.$vuetify.theme.awards_rated_5,
        '--awards-rated-6': this.$vuetify.theme.awards_rated_6,
        '--awards-rated-7': this.$vuetify.theme.awards_rated_7,
        '--awards-rated-8': this.$vuetify.theme.awards_rated_8,
        '--awards-rated-9': this.$vuetify.theme.awards_rated_9,
        '--awards-rated-10': this.$vuetify.theme.awards_rated_10
      }
    },
    paymentLoaderActive: function () {
      return this.$store.state.paymentLoader
    }
  },
  async beforeCreate () {
    const url = new URL(window.location.href)
    const token = url.searchParams.get('token')
      ? url.searchParams.get('token')
      : localStorage.token
    await api.validate(token)
      .then(() => {
        localStorage.token = token
        removeURLParam('token')
      })
      .catch(() => {
        window.location.href = api.loginUrl
      })
    await this.$store.dispatch(UPDATE_USER)
    await this.$store.dispatch(UPDATE_SEGMENTS)
    this.loaded = true
    const loader = document.getElementById('ip_splash_screen_loader')
    const className = 'loaded'
    if (loader.classList) {
      loader.classList.add(className)
    } else {
      loader.className += ' ' + className
    }
    let paypalScript = document.createElement('script')
    paypalScript.setAttribute(
      'src',
      'https://www.paypalobjects.com/api/checkout.js'
    )
    document.head.appendChild(paypalScript)


    console.log(this.$store.state.user);
    console.log(this.$store.state.user['global_warning']);
    if (
        this.$store.state.user['global_warning'] &&
        this.$store.state.user['global_warning']['active']
    ) {
      this.global_warning = {
        ...this.$store.state.user['global_warning']
      };
    }

    window.onbeforeunload = () => {
      if (this.paymentLoaderActive) {
        return 'You have attempted to leave this page. Are you sure?'
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../node_modules/normalize.css/normalize.css";
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
  }
  #app .application {
    background: #fff;
  }
  .main-wrapper {
    display: flex;
    margin-top: 65px;
  }
  .app-content {
    display: block;
    position: relative;
    flex: 1;
    margin-right: 12px;
    @media only screen and (max-width: 1259px) {
      margin-left: 12px;
    }
  }
  .app-content p,
  .app-content ul li {
    font-size: 18px;
    line-height: 1.25em;
    color: rgba(0,0,0,0.87);
  }
  .fade-slide-enter-active, .fade-slide-leave-active {
    transition:
      opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1),
      transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  }
  .fade-slide-enter {
    opacity: 0;
    transform: translateY(-48px);
  }
  .fade-slide-leave-active {
    opacity: 0;
    transform: translateY(48px);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }
  h2, h3, h4, h5, h6 {
    font-weight: bold;
    color: rgba(0, 0, 0, 0.54);
  }
  h2 {
    font-size: 26px;
    margin-bottom: 24px;
  }
  h3 {
    font-size: 24px;
    margin-bottom: 18px;
  }
  h4 {
    font-size: 22px;
    margin-bottom: 12px;
  }
  h5 { font-size: 20px; }
  h6 { font-size: 18px; }
  p {
    font-weight: normal;
    color: rgba(0, 0, 0, 0.87);
    margin-top: 24px;
    font-size: 18px;
  }
  @media only screen and (max-width: 1023px) {
    #app > #desktop_app {
      display: none;
    }
    #app > #mobile_app {
      display: block;
    }
  }
  @media only screen and (min-width: 1024px) {
    #app > #desktop_app {
      display: block;
    }
    #app > #mobile_app {
      display: none;
    }
  }
</style>


<i18n>
  {
    "en": {
      "Alert": "Alert",
      "Vote": "Vote"
    },
    "pt": {
      "Alert": "Alerta",
      "Vote": "Votar"
    }
  }
</i18n>
